import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GremlinGallery } from "../components/GremlinGallery";

export default function GremlinsPage() {
  return (
    <main data-testid="gremlins-page" className="pt-16 pb-10">
      <GremlinGallery />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 -mt-6">
        <Link
          to="/"
          state={{ scrollTo: "#shop" }}
          data-testid="gremlins-shop-link"
          className="inline-flex items-center gap-3 bg-ember text-void font-mono uppercase text-xs tracking-widest px-7 py-4 rounded-full font-medium hover:bg-emberDark transition-colors"
        >
          Shop the beans <ArrowRight size={15} />
        </Link>
      </div>
    </main>
  );
}
